import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import customSetting from "../../public/config/customSetting.json";
Vue.prototype.apiUrl = customSetting.apiUrl;
const baseApi = customSetting.apiUrl;

// 1-1 index
import state_index from "./index/state_index";
import mutations_index from "./index/mutations_index";
import actions_index from "./index/actions_index";

// 1-2~1-4 venforInfo
import state_vendorInfo from "./vendorInfo/state_vendorInfo";
import actions_vendorInfo from "./vendorInfo/actions_vendorInfo";
import mutations_vendorInfo from "./vendorInfo/mutations_vendorInfo";

// 1-5 courseApply
import state_courseApply from "./courseApply/state_courseApply";
import actions_courseApply from "./courseApply/actions_courseApply";
import mutations_courseApply from "./courseApply/mutations_courseApply";

// 1-6~1-8 ProjMgmt
import state_ProjMgmt from "./ProjMgmt/state_ProjMgmt";
import actions_ProjMgmt from "./ProjMgmt/actions_ProjMgmt";
import mutations_ProjMgmt from "./ProjMgmt/mutations_ProjMgmt";

// 2-1~2-3 UrgentRepair
import state_UrgentRepair from "./UrgentRepair/state_UrgentRepair";
import actions_UrgentRepair from "./UrgentRepair/actions_UrgentRepair";
import mutations_UrgentRepair from "./UrgentRepair/mutations_UrgentRepair";

// 2-4~2-6 dailyWorkApply
import state_dailyWorkApply from "./dailyWorkApply/state_dailyWorkApply";
import action_dailyWorkApply from "./dailyWorkApply/action_dailyWorkApply";
import mutation_dailyWorkApply from "./dailyWorkApply/mutation_dailyWorkApply";

// 2-7~2-11 ServiceCenter
import state_ServiceCenter from "./ServiceCenter/state_ServiceCenter";
import actions_ServiceCenter from "./ServiceCenter/actions_ServiceCenter";
import mutations_ServiceCenter from "./ServiceCenter/mutations_ServiceCenter";

// 2-12~2-13 InsuranceArea
import state_InsuranceArea from "./InsuranceArea/state_InsuranceArea";
import actions_InsuranceArea from "./InsuranceArea/actions_InsuranceArea";
import mutations_InsuranceArea from "./InsuranceArea/mutations_InsuranceArea";

// 2-14~2-15 PrivacyZone
import state_PrivacyZone from "./PrivacyZone/state_PrivacyZone";
import actions_PrivacyZone from "./PrivacyZone/actions_PrivacyZone";
import mutations_PrivacyZone from "./PrivacyZone/mutations_PrivacyZone";

// 2-16~2-18 ProtocolArea
import state_ProtocolArea from "./ProtocolArea/state_ProtocolArea";
import actions_ProtocolArea from "./ProtocolArea/actions_ProtocolArea";
import mutations_ProtocolArea from "./ProtocolArea/mutations_ProtocolArea";

// 3-1 PendingFiles
import state_PendingFiles from "./PendingFiles/state_PendingFiles";
import actions_PendingFiles from "./PendingFiles/actions_PendingFiles";
import mutations_PendingFiles from "./PendingFiles/mutations_PendingFiles";

// 3-2 DocSearch
import state_DocSearch from "./DocSearch/state_DocSearch";
import actions_DocSearch from "./DocSearch/actions_DocSearch";
import mutations_DocSearch from "./DocSearch/mutations_DocSearch";

// 3-3~3-12 OSH
import state_OSH from "./OSH/state_OSH";
import actions_OSH from "./OSH/actions_OSH";
import mutations_OSH from "./OSH/mutations_OSH";

// 3-13 constructionMgm
import state_constructionMgm from "./constructionMgm/state_constructionMgm";
import actions_constructionMgm from "./constructionMgm/actions_constructionMgm";
import mutations_constructionMgm from "./constructionMgm/mutations_constructionMgm";

// 0-0 frontpage
import state_frontPage from "./FrontPage/state_frontPage";
import actions_frontPage from "./FrontPage/actions_frontPage";
import mutations_frontPage from "./FrontPage/mutations_frontPage";

// 3-14~3-15 VendorLicence
import state_vendorLicense from "./VendorLicense/state_vendorLicense";
import actions_vendorLicense from "./VendorLicense/actions_vendorLicense";
import mutations_vendorLicense from "./VendorLicense/mutations_vendorLicense";

// 4-1 FineMgmt
import state_fineMgmt from "./FineMgmt/state_fineMgmt";
import actions_fineMgmt from "./FineMgmt/actions_fineMgmt";
import mutations_fineMgmt from "./FineMgmt/mutations_fineMgmt";

// 4-2 permissionMgmt
import state_permissionMgmt from "./permissionMgmt/state_permissionMgmt";
import actions_permissionMgmt from "./permissionMgmt/actions_permissionMgmt";
import mutations_permissionMgmt from "./permissionMgmt/mutations_permissionMgmt";

// 4-3 idCardApply
import state_idCardApply from "./idCardApply/state_idCardApply";
import actions_idCardApply from "./idCardApply/actions_idCardApply";
import mutations_idCardApply from "./idCardApply/mutations_idCardApply";

// 4-4 staffChange
import state_staffChange from "./staffChange/state_staffChange";
import actions_staffChange from "./staffChange/actions_staffChange";
import mutations_staffChange from "./staffChange/mutations_staffChange";

// 5-3~5-4 Board
import state_announcementInformation from "./announcementInformation/state_announcementInformation";
import actions_announcementInformation from "./announcementInformation/actions_announcementInformation";
import mutations_announcementInformation from "./announcementInformation/mutations_announcementInformation";

// 5-5~5-6 FileMgmt
import state_FileDL from "./FileDL/state_FileDL";
import actions_FileDL from "./FileDL/actions_FileDL";
import mutations_FileDL from "./FileDL/mutations_FileDL";
import actions_FileMgmt from "./FileMgmt/actions_FileMgmt";

//SpecialProject
import state_SpecialProject from "./SpecialProject/state_SpecialProject";
import actions_SpecialProject from "./SpecialProject/actions_SpecialProject";
import mutations_SpecialProject from "./SpecialProject/mutations_SpecialProject";

Vue.use(Vuex);

export default new Vuex.Store({
  // strict: true,
  getters: {},
  state: {
    // component
    headerShow: true,
    headerHeight: 0,
    breadCrumbShow: true,
    onlineTotal: 0,
    loginName: "",
    ...state_frontPage,
    ...state_index,
    ...state_vendorInfo,
    ...state_courseApply,
    ...state_ProjMgmt,
    ...state_UrgentRepair,
    ...state_dailyWorkApply,
    ...state_ServiceCenter,
    ...state_InsuranceArea,
    ...state_PrivacyZone,
    ...state_ProtocolArea,
    ...state_PendingFiles,
    ...state_DocSearch,
    ...state_OSH,
    ...state_constructionMgm,
    ...state_vendorLicense,
    ...state_fineMgmt,
    ...state_permissionMgmt,
    ...state_idCardApply,
    ...state_staffChange,
    ...state_announcementInformation,
    ...state_FileDL,
    ...state_SpecialProject,

    // pagination
    pageSize: 10,
    currentPage: 1,

    // error 999
    maintainData: [],

    // selected list
    selectedList: [],
    remoteSearchNote: "輸入後請按下Enter鍵搜尋",
    // apim
    apim: {},
  },

  mutations: {
    ...mutations_frontPage,
    ...mutations_index,
    ...mutations_vendorInfo,
    ...mutations_courseApply,
    ...mutations_ProjMgmt,
    ...mutations_UrgentRepair,
    ...mutation_dailyWorkApply,
    ...mutations_ServiceCenter,
    ...mutations_InsuranceArea,
    ...mutations_PrivacyZone,
    ...mutations_ProtocolArea,
    ...mutations_PendingFiles,
    ...mutations_DocSearch,
    ...mutations_OSH,
    ...mutations_constructionMgm,
    ...mutations_vendorLicense,
    ...mutations_fineMgmt,
    ...mutations_permissionMgmt,
    ...mutations_idCardApply,
    ...mutations_staffChange,
    ...mutations_announcementInformation,
    ...mutations_FileDL,
    ...mutations_SpecialProject,

    // select list (state 要把變數改掉)
    CLEAR_SELECTED_LIST(state, el) {
      state.users.find((user) => {
        if (user.id === el.id) {
          user.checked = false;
        }
      });
      state.selectedList = state.selectedList.filter((e) => e.id !== el.id);
    },

    // pagination
    CHANGE_PAGE_HANDLER(state, obj) {
      const currentPageNumber = (obj.page - 1) * state.pageSize;
      const lastPageNumber = obj.page * state.pageSize;
      if (obj.paramsListName || obj.paramsDataName) {
        state[obj.paramsListName] = state[obj.paramsDataName].slice(
          currentPageNumber,
          lastPageNumber
        );
      }
      state.currentPage = obj.page;
    },

    // hiding components
    HEADER_HANDLER(state, show) {
      state.headerShow = show;
      if (!show) {
        state.headerHeight = 0;
      } else {
        state.headerHeight = "60px";
      }
    },
    BREADCRUMB_HANDLER(state, show) {
      state.breadCrumbShow = show;
      // console.log(state);
    },
    CURRENT_PAGE_INIT(state) {
      state.currentPage = 1;
    },

    // error 999 系統維護中
    MAINTAIN_HADNDLER(state, data) {
      state.maintainData = data;
    },
  },

  actions: {
    ...actions_frontPage,
    ...actions_index,
    ...actions_vendorInfo,
    ...actions_courseApply,
    ...actions_ProjMgmt,
    ...actions_UrgentRepair,
    ...action_dailyWorkApply,
    ...actions_ServiceCenter,
    ...actions_InsuranceArea,
    ...actions_PrivacyZone,
    ...actions_ProtocolArea,
    ...actions_PendingFiles,
    ...actions_DocSearch,
    ...actions_OSH,
    ...actions_constructionMgm,
    ...actions_vendorLicense,
    ...actions_fineMgmt,
    ...actions_permissionMgmt,
    ...actions_idCardApply,
    ...actions_staffChange,
    ...actions_announcementInformation,
    ...actions_FileDL,
    ...actions_FileMgmt,
    ...actions_SpecialProject,

    commonDownloadPdf: (context, { file_id, router_Name }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `${baseApi}/${router_Name}/DownloadPdf?file_id=${encodeURIComponent(
            file_id
          )}`,
          method: "GET",
          responseType: "blob",
        })
          .then((res) => resolve(res))
          .catch((err) => {
            Vue.prototype.$message({
              type: "error",
              duration: 5000,
              showClose: true,
              message: `失敗: 檔案下載失敗`,
            });
            reject(err);
          });
      });
    },
    commonExportExcel: (context, { obj, router_Name, action_Name }) => {
      return new Promise((resolve, reject) => {
        let qryString = [];
        let params = "";
        Object.keys(obj).forEach((e) => {
          if (obj[e]) {
            qryString.push(encodeURI(`${e}=${obj[e]}`));
          }
        });
        params = qryString.join("&");
        axios({
          url: `${baseApi}/${router_Name}/${action_Name}?${params}`,
          method: "GET",
          responseType: "blob",
        })
          .then((res) => resolve(res))
          .catch((err) => {
            Vue.prototype.$message({
              type: "error",
              duration: 5000,
              showClose: true,
              message: `失敗: excel下載失敗`,
            });
            reject(err);
          });
      });
    },
  },
});
